import React, { useState, useEffect } from 'react';
import { api } from "../../app/http-common";
import { useIsAdmin } from '../../hooks/useFrontegg';

// FineTuning component
const FineTuning = ({ setActiveTab }) => {
    const isAdmin = useIsAdmin();
    const [fineTuningData, setFineTuningData] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [editingAnswer, setEditingAnswer] = useState('');
    const [error, setError] = useState('');
    const [saveMessage, setSaveMessage] = useState('');
    const [selectedType, setSelectedType] = useState('claim_clustering'); // Default type selection

    const fetchFineTuningData = async (type) => {
        try {
            setLoading(true);
            const response = await api.fineTuning({ type }); // Call with selected type
            setFineTuningData(response);
            setLoading(false);
            setError('');
        } catch (error) {
            setError('Failed to fetch fine-tuning data.');
            setLoading(false);
        }
    };

    // Fetch data when type is selected
    useEffect(() => {
        if (selectedType) {
            fetchFineTuningData(selectedType);
        }
    }, [selectedType]); // Refetch whenever the selectedType changes

    useEffect(() => {
        if (fineTuningData.length > 0) {
            setEditingAnswer(fineTuningData[currentIndex].answer);
        }
    }, [currentIndex, fineTuningData]);

    const handleNext = () => {
        if (currentIndex < fineTuningData.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const handleAnswerChange = (e) => {
        setEditingAnswer(e.target.value);
    };

    const handleSave = async () => {
        const updatedObject = {
            ...fineTuningData[currentIndex],
            answer: editingAnswer,
        };

        try {
            await api.updateFineTuning(updatedObject);
            const updatedData = [...fineTuningData];
            updatedData[currentIndex] = updatedObject;
            setFineTuningData(updatedData);
            setSaveMessage('Answer updated successfully!');
            setTimeout(() => setSaveMessage(''), 3000); // Clear message after 3 seconds
        } catch (error) {
            setSaveMessage('Failed to update the answer. Try again.');
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString();
    };

    if (!isAdmin) {
        return (
            <div>
                <button onClick={() => setActiveTab('searchArticles')}>Close</button>
                <p style={{ color: 'red' }}>Only for admins</p>
            </div>
        );
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div>
            {/* Dropdown for selecting type */}
            <div>
                <label>Select Type: </label>
                <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
                    <option value="claim_clustering">Claim Clustering</option>
                    <option value="categories">Categories</option>
                    <option value="break_into_claims">Break Into Claims</option>
                    <option value="story_clustering">Stories Clustering</option>
                    <option value="story_clustering_size_1">Stories Size 1 Clustering</option>
                </select>
            </div>

            {/* If no data is available for the selected type */}
            {fineTuningData.length === 0 ? (
                <div>No fine-tuning data available for {selectedType}.</div>
            ) : (
                <div>
                    <div>
                        <h3>Fine-Tuning Review</h3>
                        <div style={{marginTop: '20px'}}>
                            <button onClick={handlePrevious} disabled={currentIndex === 0}>
                                Previous
                            </button>
                            <button onClick={handleNext} disabled={currentIndex === fineTuningData.length - 1}>
                                Next
                            </button>
                        </div>
                        <div style={{marginTop: '10px'}}>
                            <p>
                                {fineTuningData[currentIndex].url ? (
                                    <a href={fineTuningData[currentIndex].url} target="_blank"
                                       rel="noopener noreferrer">
                                        {fineTuningData[currentIndex].url}
                                    </a>
                                ) : (
                                    'N/A'
                                )}
                            </p>
                            <p>
                                <strong>Last Updated By:</strong> {fineTuningData[currentIndex].updatedBy || 'N/A'}
                            </p>
                            <p>
                                <strong>Last Updated
                                    At:</strong> {formatDate(fineTuningData[currentIndex].updatedAt) || 'N/A'}
                            </p>
                        </div>

                        <p style={{whiteSpace: 'pre-wrap'}}>
                            <strong>Prompt:</strong> {fineTuningData[currentIndex].prompt}
                        </p>
                        <textarea
                            value={editingAnswer}
                            onChange={handleAnswerChange}
                            rows={4}
                            style={{width: '100%', height: '400px'}}
                        />
                        <button onClick={handleSave}>Save</button>
                        {saveMessage && <p>{saveMessage}</p>}
                        {fineTuningData[currentIndex].parsed &&
                            (<p style={{whiteSpace: 'pre-wrap'}}>
                                <strong>Parsed:</strong> {fineTuningData[currentIndex].parsed}
                            </p>)}

                    </div>

                    {/* Display updatedBy and updatedAt */}

                </div>
            )}
        </div>
    );
};

export default FineTuning;
